import { prepareDate } from '../../../utils/Calendar';
const initialState = {
  layout: 'list',
  calendarView: 'DAY',
  calendarDate: prepareDate(new Date()),
  calendarEntrySize: 'regular',
  calendarInModal: false,
  calendarDayViewHideTime: false
};

const LayoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_LOGOUT' || 'INVALID_USER':
      return initialState;
    case 'CALENDAR_IN_MODAL': {
      return {
        ...state,
        calendarInModal: action.payload
      };
    }
    case 'CALENDAR_VIEW_DAY_HIDETIME':
      return {
        ...state,
        calendarDayViewHideTime: action.payload
      };
    case 'CALENDAR_VIEW':
      return {
        ...state,
        calendarView: action.payload
      };
    case 'CALENDAR_ENTRY_SIZE':
      return {
        ...state,
        calendarEntrySize: action.payload
      };
    case 'CALENDAR_DATE':
      return {
        ...state,
        calendarDate: action.payload
      };
    default:
      return state;
  }
};

export default LayoutReducer;
